import config from "./api.config";

export const getEndpointUrl = (endpointType) =>
  config.api.endpoints[endpointType] || "";
